<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title" id="heading_id_2">TEAMWORK IS AN INDIVIDUAL SKILL</h1>
<h1 class="subtitle" id="heading_id_3">Getting Your Work Done When Sharing Responsibility</h1><br/>
<br/>
<br/>
<br/>
<h2 class="author" id="heading_id_4">Christopher M. Avery<br/>
    with Meri Aaron Walker<br/>
    and Erin O’ Toole Murphy</h2><br/>
<br/>
<div class="image"><img alt="image" src="Images/00001.jpg"/></div>
<p><span>BERRETT-KOEHLER PUBLISHERS, INC.<br/>
    San Francisco</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?05eb9d32